import { useEffect } from 'react';
import { GOOGLE_FONTS_HREF } from '../theme';
const FONTS_LINK_ID = 'screen-google-fonts';
// Loads the TV fonts and removes page scrollbars while the screen is mounted.
export const useScreenPageSetup = () => {
    useEffect(() => {
        if (!document.getElementById(FONTS_LINK_ID)) {
            const link = document.createElement('link');
            link.id = FONTS_LINK_ID;
            link.rel = 'stylesheet';
            link.href = GOOGLE_FONTS_HREF;
            document.head.appendChild(link);
        }
        const { overflow: htmlOverflow } = document.documentElement.style;
        const { overflow: bodyOverflow, margin: bodyMargin } = document.body.style;
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        document.body.style.margin = '0';
        return () => {
            document.documentElement.style.overflow = htmlOverflow;
            document.body.style.overflow = bodyOverflow;
            document.body.style.margin = bodyMargin;
        };
    }, []);
};
